import React from "react";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import jszip from 'jszip';
// @ts-ignore
import pdfMake from 'pdfmake/build/pdfmake';
// @ts-ignore
import pdfFonts from 'pdfmake/build/vfs_fonts';
// @ts-ignore
pdfMake.vfs = pdfFonts.vfs;
window.JSZip = jszip;
DataTable.use(DT);
const scoreTypesName = {
    hole_in_one: "Hoyo en uno",
    birdie: "Birdie",
    eagle: "Eagle"
};
const ScoreTypesStatsTableView = ({ data, competitionName, roundNumber, view }) => {
    const dataToTableFormat = () => {
        const tableData = [];
        Object.values(data).forEach(({ scoreTypeKey, players }) => {
            players.forEach(({ playerName, holeNumber, createdAt }) => {
                tableData.push({
                    type: scoreTypesName[scoreTypeKey],
                    hole: holeNumber,
                    name: playerName,
                    date: createdAt
                });
            });
        });
        return tableData;
    };
    const tableColumns = [
        { data: 'type', title: 'Tipo' },
        { data: 'hole', title: 'Hoyo' },
        { data: 'name', title: 'Nombre' },
        { data: 'date', title: 'Fecha' }
    ];
    const exportedFileName = 'Resultados destacados - ' + competitionName + (roundNumber ? ` - Jornada ${roundNumber}` : '');
    return (React.createElement("div", { className: "tableContainer" },
        React.createElement(DataTable, { data: dataToTableFormat(), columns: tableColumns, className: "ui celled striped table", options: Object.assign(Object.assign({ paging: true, searching: true, ordering: true, order: [[1, 'asc']], pageLength: 25, lengthMenu: [[25, 50, -1], [25, 50, "Todos"]] }, ("gestion_results" === view && {
                layout: {
                    topStart: 'buttons'
                },
                buttons: [
                    {
                        extend: 'csv',
                        text: 'Exportar CSV',
                        className: 'ui button',
                        title: 'CSV - ' + exportedFileName
                    },
                    {
                        extend: 'pdf',
                        text: 'Exportar PDF',
                        className: 'ui button',
                        title: 'PDF - ' + exportedFileName
                    }
                ]
            })), { language: {
                    search: "Buscar:",
                    lengthMenu: "Mostrar _MENU_ resultados",
                    info: "Mostrando _START_ a _END_ de _TOTAL_ resultados",
                    infoEmpty: "Mostrando 0 a 0 de 0 resultados",
                    infoFiltered: "(filtrado de _MAX_ resultados totales)",
                    zeroRecords: "No se encontraron resultados",
                    paginate: {
                        first: "Primero",
                        last: "Último",
                        next: "Siguiente",
                        previous: "Anterior"
                    }
                } }) })));
};
export default ScoreTypesStatsTableView;
